<template>
    <div class="inner">
        <div class="headline">
            <h1>New screening</h1>
            <p>{{getSingleProperty.address}} · {{getSingleProperty.zip_code}} {{getSingleProperty.city}} </p>
        </div>

        <div class="content-box small">
            <div class="container">
                <h2>Who do you want to screen?</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco.</p>

                <form class="send-invite">
                    <div class="input-container">
                        <input  id="email" type="text" v-model="email"
                            class="form-control" name="email" placeholder="Email..." autofocus>
                    </div>
                    <div class="set-deadline" @click="toggle()">
                        <simple-svg
                            :filepath="'/images/SVG/Clock.svg'"
                            :width="'20px'"
                            :height="'20px'"
                        />
                        <span>Set a deadline</span>
                    </div>

                    <datepicker :inline="true" v-model="deadline" name="deadline" class="datepicker" v-if="isOpen"></datepicker>


                </form>
                <button id="send-invite" disabled @click.prevent="sendInvite" class="purple">Send screening request</button>
            </div>

        </div>



        <p>Number of invites {{numberOfInvites}}</p>
    </div>
</template>

<script>
    import createEntity from "../../mixins/create-entity";
    import {store} from "../../store";
    import {mapGetters} from "vuex";
    import vue2Dropzone from 'vue2-dropzone'
    import 'vue2-dropzone/dist/vue2Dropzone.min.css'
    import Datepicker from 'simple-vue-datepicker';
    export default {
        mixins: [createEntity],
        async beforeRouteEnter(to, from, next){
            if(to.params.id){
                store.dispatch('fetchSingleProperty', to.params.id);
                next();
            }
        },
        components: {
            vueDropzone: vue2Dropzone,
            Datepicker
        },
        data: () => ({
            numberOfInvitations: 0,
            email: '',
            message: '',
            deadline: '',
            dropzoneOptions: {},
            isOpen: false
        }),
        created(){
            this.dropzoneOptions = {
                url: window.config.apiUrl + 'api/contract/upload',
                thumbnailWidth: 150,
                maxFilesize: 0.5,
                headers: {
                    'Authorization': 'Bearer ' + this.getToken
                },
                autoProcessQueue: false,
                addRemoveLinks: true,
                uploadMultiple: true,
            }
        },
        computed:{
            ...mapGetters([
                'getSingleProperty',
                'getToken'
            ]),
            numberOfInvites: function(){
               return this.getSingleProperty.invitation_count + this.numberOfInvitations;
            },
            test: function () {
                this.$refs.myVueDropzone.vdropzone-file-added(file);
            }
        },
        methods:{
            toggle: function(){
                this.isOpen = !this.isOpen
            },
            customFormatter(date) {
              return moment(date).format('d MMMM YYYY');
            },
            async sendInvite(){

                    await axios({
                        method: 'POST',
                        url: this.$root.apiUrl + 'api/invitation/send',
                        cancelToken: window.AuthorizationCancelSource.token,
                        data:{
                            email: this.email,
                            property_id: this.getSingleProperty.id,
                            deadline: this.deadline,
                            message: this.message
                        }
                    });
                    await this.$store.dispatch('fetchProperties');
                    this.$store.dispatch('fetchSentInvitations', true);
                    this.email = '';
                    this.deadline = '';
                    this.message = '';
                    this.numberOfInvitations++;

            },
            uploadFiles(){
                this.$refs.myVueDropzone.processQueue();
            },
            uploadSuccess(file, response){
                let scope = this;
                setTimeout(function () {
                    scope.$refs.myVueDropzone.removeAllFiles()
                }, 2000);
            },
            sendingFiles(file, xhr, formData){
                formData.append('property_id', this.getSingleProperty.id);
            }
        }
    }
</script>

<style scoped>

</style>
